export const CHOOSE_IMAGE_BUTTON_TEXT = "Choose Image";
